import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface HttpErrorModel {
  status?: number;
  message: string;
  /**
   * Structured detail a server error may carry beside its message — a 409
   * from the sale routes names the conflicting sale here ({ saleID, saleUUID })
   * so the page can open its receipt. Undefined when the body has none.
   */
  data?: any;
  /**
   * The response body as the server sent it. Callers that act on a structured
   * failure (a declined card, a moved price, a refused message) read it as
   * err.error, the HttpErrorResponse field this model replaces.
   */
  error?: any;
}

export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorMsg: HttpErrorModel = { message: '' };

        if (error.error instanceof ErrorEvent) {
          errorMsg.message = error.error.message;
        } else {
          errorMsg.status = error.status;
          errorMsg.error = error.error;
          const body =
            error.error && typeof error.error === 'object' ? error.error : undefined;
          const serverError = body
            ? body.error || body.err_msg
            : typeof error.error === 'string'
              ? error.error
              : undefined;
          errorMsg.message = serverError || error.message;
          if (body && body.data !== undefined) {
            errorMsg.data = body.data;
          }
        }

        return throwError(() => errorMsg);
      })
    );
  }
}
